import React from 'react';
import { AppBar, Toolbar, Typography, Box, Menu, MenuItem } from '@mui/material';
import { AccountCircle, Logout } from '@mui/icons-material';
import { useAuth } from "../contexts/AuthContext";

const CustomAppBar = () => {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="fixed" sx={{ backgroundColor: 'inherit', }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', minHeight: 64 }}>
        {/* Left Section */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h6" sx={{ color: 'var(--primary-color)' }}>欢乐宝</Typography>
        </Box>

        {/* Right Section */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <AccountCircle sx={{ fontSize: 28, color: 'var(--primary-color)', marginRight: 1 }} />
          <Typography variant="subtitle1"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            sx={{ color: 'var(--primary-color)' }}>
            {user?.username || 'demoUser'}
          </Typography>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            sx={{ 
              '& .MuiMenu-paper': { backgroundColor: 'var(--bg-secondary-color)', color: '#fff' },
              '& .MuiMenuItem-root': { 
                color: '#fff',
                '&:hover': { backgroundColor: '#333' },
               },
            }}
          >
            <MenuItem onClick={() => logout()}>
              <Logout sx={{ marginRight: 1 }} />
              登出
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default CustomAppBar;
